// CRM tizimlari — xizmat sahifasi kontenti (Innobek)
// SEO: "CRM tizim", "CRM yaratish", "CRM ishlab chiqish", "mijozlarni boshqarish tizimi",
// "savdo avtomatlashtirish", "amoCRM Bitrix24 alternativa".
// Asosiy xabar: shablon emas — sizning savdo jarayoningiz ostida qurilgan tizim.

const uz = {
    meta: {
        title: "CRM tizimlari — biznesingiz ostida CRM yaratish, 18 mln so'mdan",
        description:
            "CRM tizimlari ishlab chiqish: savdo voronkasi, mijozlar bazasi, hisobotlar. Shablon emas — jarayoningiz ostida. 18 mln so'mdan, oylik abonent to'lovi yo'q.",
        keywords: [
            "CRM tizimlari",
            "CRM yaratish",
            "CRM ishlab chiqish narxi",
            "mijozlarni boshqarish tizimi",
            "savdo avtomatlashtirish",
            "individual CRM",
            "amoCRM alternativa",
            "Bitrix24 alternativa",
            "CRM Toshkent",
        ],
    },

    hero: {
        eyebrow: "CRM tizimlari",
        h1: "CRM tizimlari — biznesingizga moslashtirilgan sotuv boshqaruvi",
        lead:
            "Biz tayyor CRM shablonini sozlab bermaymiz. Avval savdo jarayoningizni chizamiz, keyin tizimni aynan shu jarayon ostida quramiz. Natijada: ortiqcha tugma yo'q, oylik abonent to'lovi yo'q, kod va mijozlar bazasi sizniki.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "8–14 haftada ishga tushadi",
            "Oylik abonent to'lovi yo'q",
            "Kod va baza to'liq sizniki",
        ],
    },

    intro: {
        h: "CRM tizimi nima va u tayyor dasturdan nimasi bilan farq qiladi?",
        p: [
            "CRM (Customer Relationship Management) — mijozlar bazasi, savdo voronkasi, vazifalar va hisobotlarni bitta oynada boshqaradigan tizim. U qo'ng'iroq, Instagram xabari va Telegram arizasini bir joyga yig'adi. Har bir mijoz qaysi bosqichda ekani, kim javobgar ekani va keyingi qadam qachon bo'lishi doim ko'rinib turadi.",
            "Tayyor CRM'lar — amoCRM, Bitrix24 va shunga o'xshashlar — universal qilib yozilgan. Ya'ni ular hech bir kompaniyaga aynan mos emas. Shundan ikkita og'riq chiqadi. Birinchisi: siz o'z jarayoningizni tizimga moslashtirasiz, aksincha emas. Ikkinchisi: har oy, har bir xodim uchun obuna to'laysiz. Jamoa 15 kishi bo'lsa, uch-to'rt yilda bu summa individual tizim narxidan oshib ketadi.",
            "Innobek CRM tizimlarini noldan quradi. Avval jarayon xaritasini chizamiz: mijoz qaysi kanaldan keladi, kim bilan gaplashadi, qanday bosqichlardan o'tadi, qaysi hujjat kerak bo'ladi. Keyin shu xaritaga qarab modullarni yozamiz. Ishlatilmaydigan maydon qurilmaydi — menejer tizimni bir haftada emas, bir kunda o'zlashtiradi.",
            "Halol aytamiz: CRM har bir biznesga kerak emas. Agar oyiga 20–30 ta ariza olsangiz va hammasini bitta odam yuritsa, Excel hali yetadi. CRM ariza oqimi kunlik hisobga o'tganda, savdo bo'limida ikkitadan ko'p odam ishlaganda yoki bitimlar unutilgani uchun pul yo'qotila boshlaganda o'zini oqlaydi.",
            "Yana bir muhim jihat — CRM sehrli tugma emas. Agar savdo jarayoningiz og'zaki kelishuvlarga tayansa va hech kim uni yozma qayd etmasa, tizim faqat tartibsizlikni raqamlashtiradi. Shuning uchun biz loyihani dasturlashdan emas, jarayonni tartibga solishdan boshlaymiz. Ko'pincha tahlil bosqichida mijozning o'zi ortiqcha kelishuvlarni va takrorlanadigan qadamlarni ko'rib qoladi — bu esa tizim narxidan ham qimmatroq foyda beradi.",
        ],
    },

    definition: {
        term: "CRM tizimi nima?",
        text:
            "CRM tizimi — mijozlar bazasi, savdo voronkasi, vazifalar va hisobotlarni bitta ma'lumotlar bazasida birlashtirib, sotuv jarayonini boshidan oxirigacha nazorat qiladigan dastur. Individual CRM esa shablon asosida emas, kompaniyaning o'z jarayoni ostida yoziladi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida hisob-faktura chiqadigan «qo'shimcha» emas — eng bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va savdo jarayoni tahlili",
            "Jarayon xaritasi: mijoz qayerdan kelib, qanday bosqichlardan o'tishi",
            "Figma'da interfeys prototipi va dizayn",
            "Eski ma'lumotlarni ko'chirish: Excel, amoCRM, Bitrix24",
            "Rollar va kirish huquqlari sozlamasi",
            "Serverga o'rnatish, domen va HTTPS sertifikati",
            "Har kunlik avtomatik zaxira nusxa (backup)",
            "Xodimlar uchun o'qitish sessiyasi va video-qo'llanma",
            "Git repozitoriysi va kodning to'liq mulkchiligi",
            "Texnik hujjat: modullar tavsifi va administrator qo'llanmasi",
            "Mobil brauzerda ishlashini tekshirish va tuzatish",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "CRM tizimi biznesga nima beradi",
        sub: "CRM — xarajat emas, yo'qotilayotgan bitimlarni qaytaradigan vosita. Quyida u aniq nimani hal qiladi.",
        items: [
            {
                t: "Ariza yo'qolmaydi",
                d: "Instagram Direct, telefon qo'ng'irog'i, sayt formasi va Telegram xabari — hammasi bitta voronkaga tushadi. «Unutib qo'yibmiz» degan sabab yo'qoladi, chunki har bir arizada muddat va javobgar bor.",
            },
            {
                t: "Har oy to'lamaysiz",
                d: "Tayyor CRM har bir xodim uchun oylik obuna oladi. Individual tizimda to'lov bir martalik. Jamoa qancha o'ssa, tejamkorlik shuncha ortadi — yangi menejer uchun litsenziya sotib olmaysiz.",
            },
            {
                t: "Jarayon sizniki bo'lib qoladi",
                d: "Voronka bosqichlari, maydonlar va hujjat shakllari sizning ishlash uslubingizga moslanadi. Biznesni dasturga emas, dasturni biznesga moslaymiz — bu eng katta farq.",
            },
            {
                t: "Menejer ishi raqamda ko'rinadi",
                d: "Kim nechta ariza oldi, qanchasi bitimga aylandi, qaysi bosqichda to'xtab qoldi, o'rtacha javob vaqti qancha. Bahs o'rniga hisobot — mukofot ham shu raqamlarga tayanadi.",
            },
            {
                t: "Baza kompaniyada qoladi",
                d: "Ma'lumotlar sizning serveringizda yoki siz tanlagan bulutda turadi. Menejer ishdan ketganda telefonidagi kontaktlar bilan birga mijozlar bazasi ham ketmaydi.",
            },
            {
                t: "Keyin kengaytiriladi",
                d: "Ombor, hujjat aylanmasi, moliya yoki HR moduli keyinroq qo'shiladi. Boshqa provayder tarifini kutmaysiz va migratsiya qilmaysiz — bitta kod bazasi o'sib boradi.",
            },
            {
                t: "Qo'lda ish kamayadi",
                d: "Shartnoma, hisob-faktura va akt shablondan avtomatik chiqadi. Menejer kuniga bir-ikki soatni hujjat terishga emas, mijoz bilan gaplashishga sarflaydi. Xato va qayta chiqarish ham kamayadi.",
            },
            {
                t: "Yangi xodim tez ishga kirishadi",
                d: "Voronka bosqichlari va vazifalar yangi menejerga nima qilish kerakligini o'zi ko'rsatadi. Moslashuv davri haftalardan kunlarga qisqaradi, mijoz esa kadr almashuvini sezmaydi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar qiladi",
        h: "Qanaqa bizneslarga individual CRM mos keladi",
        sub: "Jarayoni standart bo'lmagan yoki tayyor tizimga sig'magan kompaniyalar.",
        items: [
            {
                t: "Ulgurji savdo va distribyutsiya",
                d: "Dilerlar, har mijozga alohida narx ro'yxati, qarzdorlik nazorati va omborga bog'langan buyurtmalar.",
            },
            {
                t: "Ishlab chiqarish",
                d: "Buyurtmadan tayyor mahsulotgacha: kalkulyatsiya, bosqichlar, xom ashyo zaxirasi va muddat nazorati.",
            },
            {
                t: "Logistika va yuk tashish",
                d: "Ariza, marshrut, haydovchi, hujjat aylanmasi va mijoz bilan aloqa tarixi bitta tizimda.",
            },
            {
                t: "Qurilish va montaj",
                d: "Obyektlar, smeta, bosqichlar, pudratchilar va bajarilgan ish aktlari bo'yicha nazorat.",
            },
            {
                t: "Klinika va xizmat markazlari",
                d: "Bemor kartasi, navbat, xizmatlar tarixi va takroriy tashrif eslatmalari — maxfiylikka rioya qilgan holda.",
            },
            {
                t: "Ta'lim markazlari",
                d: "Lid, sinov darsi, guruhlar, to'lov jadvali va davomat — o'quv jarayoniga moslashtirilgan holda.",
            },
            {
                t: "Ko'chmas mulk agentliklari",
                d: "Obyektlar bazasi, ko'rsatuvlar jadvali, agentlar komissiyasi va xaridor bilan sotuvchi kesimidagi bitimlar.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "CRM tizimi narxi — uchta tarif",
        sub: "Narxlar oshkora va bir martalik. Foydalanuvchi soni uchun qo'shimcha haq olinmaydi.",
        note:
            "Yakuniy hisob-kitob bepul jarayon tahlilidan keyin, modullar ro'yxatiga qarab tasdiqlanadi. To'lov bosqichma-bosqich: avans, oraliq topshirish va yakun. Server yoki bulut xarajati (odatda oyiga 300 ming so'mdan) narxga kirmaydi va to'g'ridan-to'g'ri provayderga to'lanadi. Savol bo'lsa qo'ng'iroq qiling: +998 90 954 12 62.",
        tiers: [
            {
                name: "Start",
                tagline: "Savdo bo'limi uchun CRM",
                price: "18 000 000",
                priceNote: "so'mdan",
                term: "5–8 hafta",
                best: "Arizalarni yo'qotmaslik va savdo bo'limini tartibga solish",
                features: [
                    "Jarayon tahlili va voronkani sizning bosqichlaringiz bo'yicha qurish",
                    "Mijozlar hamda kompaniyalar bazasi, to'liq aloqa tarixi",
                    "Bitimlar va kanban ko'rinishi, bosqichlar bo'yicha surish",
                    "Vazifalar, eslatmalar va kalendar",
                    "Rollar: menejer, bo'lim boshlig'i, administrator",
                    "Sayt formalari va Telegram'dan lidlarni avtomatik qabul qilish",
                    "Telegram bot orqali yangi ariza bildirishnomasi",
                    "Asosiy hisobotlar: voronka, menejerlar kesimi, konversiya",
                    "Excel'dan ma'lumot ko'chirish va eksport",
                    "O'qitish hamda 6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "CRM va kompaniya jarayonlari",
                price: "38 000 000",
                priceNote: "so'mdan",
                term: "10–16 hafta",
                best: "Savdodan tashqari ombor, hujjat va moliyani ham bitta tizimga yig'ish",
                featured: true,
                features: [
                    "Start tarifidagi barcha imkoniyatlar",
                    "Ombor va qoldiq hisobi, ta'minotchilar bazasi",
                    "Hujjatlar: shartnoma, hisob-faktura, akt — avtomatik shakllantirish",
                    "Moliya bloki: to'lovlar, qarzdorlik, kassa va daromad hisoboti",
                    "1C yoki buxgalteriya dasturi bilan ikki tomonlama integratsiya",
                    "IP-telefoniya: qo'ng'iroqni yozib olish va mijoz kartasiga bog'lash",
                    "Avtomatlashtirish: bosqich o'zgarganda vazifa va hujjat o'zi yaratiladi",
                    "Boshqaruv paneli: real vaqtdagi KPI ko'rsatkichlari",
                    "Mobil brauzerga to'liq moslashuv yoki PWA",
                    "Ko'p filial va bo'linmalar kesimida bo'lish",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Murakkab integratsiyali yechim",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Holdinglar, ko'p yuridik shaxsli va murakkab integratsiyali korxonalar",
                features: [
                    "ERP darajasidagi modullar: ishlab chiqarish, byudjet, HR",
                    "Dilerlar va hamkorlar uchun alohida B2B portal",
                    "Dala xodimlari uchun mobil ilova (iOS va Android)",
                    "Sun'iy intellekt: lidlarni baholash va sotuv bashorati",
                    "Bir nechta yuridik shaxs hamda valyuta bilan ishlash",
                    "Xavfsizlik auditi, audit jurnali va zaxira siyosati",
                    "Ma'lumotlarni o'z serveringizda joylashtirish (on-premise)",
                    "Kelishilgan SLA bo'yicha doimiy qo'llab-quvvatlash",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "CRM tizimi qanday quriladi",
        sub: "Oltita bosqich. Eng muhimi — birinchisi: kod yozilishidan oldin jarayon tushunib olinadi.",
        steps: [
            {
                t: "Jarayon tahlili",
                time: "1–2 hafta",
                d: "Savdo jarayoningizni menejerlar bilan birga chizamiz: mijoz qayerdan keladi, kim ishlaydi, qanday bosqichlar va hujjatlar bor. Shu yerda ko'pincha ortiqcha bosqichlar ham topiladi.",
            },
            {
                t: "Texnik topshiriq",
                time: "3–5 kun",
                d: "Modullar, rollar, maydonlar va hisobotlar yozma ravishda tasdiqlanadi. Aynan shu hujjat asosida narx va muddat qat'iylashadi — keyin «buni hisobga olmagan ekanmiz» bo'lmaydi.",
            },
            {
                t: "Interfeys dizayni",
                time: "1–2 hafta",
                d: "Figma'da prototip tayyorlanadi. Xodimlar uni bosib ko'radi va noqulaylik kod yozilmasdan oldin tuzatiladi. Bu bosqich keyingi qayta ishlashlarni ancha kamaytiradi.",
            },
            {
                t: "Dasturlash",
                time: "3–10 hafta",
                d: "Modullar navbat bilan quriladi va har ikki haftada sizga ko'rsatiladi. Integratsiyalar — 1C, telefoniya, Telegram, to'lov tizimlari — shu bosqichda ulanadi.",
            },
            {
                t: "Ma'lumot ko'chirish va o'qitish",
                time: "1–2 hafta",
                d: "Eski baza ko'chiriladi, xodimlar o'qitiladi. Bir necha kun eski va yangi tizim parallel ishlaydi — bu ma'lumot yo'qolishining oldini oladi.",
            },
            {
                t: "Ishga tushirish va kuzatuv",
                time: "6 oy",
                d: "Tizim to'liq ishga tushadi. Birinchi haftalarda foydalanish kuzatiladi, real ish asosida tuzatishlar kiritiladi va xatoliklar bepul bartaraf etiladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan boshqaruv tizimlari",
        sub: "Har bir tizim noldan qurilgan: jarayon tahlili, dizayn va dasturlash biz tomonimizdan bajarilgan.",
        cta: "Barcha loyihalar",
        slugs: ["grandpharm", "tezlift", "family-group", "befitpro"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "CRM tizimlari bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "CRM tizimi yaratish qancha turadi?",
                a: "Narxlar 18 000 000 so'mdan boshlanadi. Bu summaga savdo bo'limi uchun to'liq ishlaydigan CRM kiradi: mijozlar bazasi, voronka, vazifalar, rollar, Telegram bildirishnomalari va hisobotlar. Ombor, hujjat aylanmasi, moliya va 1C integratsiyasi qo'shilsa, narx 38 000 000 so'mdan boshlanadi. Aniq raqam bepul jarayon tahlilidan keyin beriladi.",
            },
            {
                q: "CRM ishlab chiqish qancha vaqt oladi?",
                a: "Start tarifi 5–8 haftada, Business tarifi 10–16 haftada topshiriladi. Muddat modullar soniga va integratsiyalarga bog'liq. 1C yoki telefoniya ulanishi odatda 1–2 hafta qo'shadi. Eng uzun bosqich dasturlash emas, balki jarayon tahlili va kelishuv bo'ladi — shuning uchun sizning jamoangiz qanchalik tez javob bersa, loyiha shuncha tez tugaydi.",
            },
            {
                q: "Nega tayyor CRM emas, individual tizim?",
                a: "Tayyor CRM universal qilib yozilgan, shuning uchun u hech bir kompaniyaga aynan mos kelmaydi. Siz o'z jarayoningizni tizimga moslashtirasiz va har oy har bir foydalanuvchi uchun to'laysiz. Individual tizimda aksincha: dastur sizning bosqichlaringizga moslashadi, to'lov bir martalik, kod esa sizga tegishli bo'lib qoladi.",
            },
            {
                q: "Individual CRM tayyor tizimdan qimmatroq emasmi?",
                a: "Birinchi to'lov kattaroq, bu rost. Lekin tayyor CRM har oy va har bir foydalanuvchi uchun to'lanadi. Jamoa 10–20 kishi bo'lsa, uch-to'rt yilda obuna summasi individual tizim narxidan oshadi. Ustiga siz baribir moslashtirish va integratsiya uchun alohida to'laysiz. Uzoq muddatda individual tizim arzonroq chiqadi.",
            },
            {
                q: "amoCRM yoki Bitrix24'dagi ma'lumotlarni ko'chira olasizmi?",
                a: "Ha. amoCRM, Bitrix24, Excel jadvallari yoki boshqa tizimdan mijozlar, bitimlar, aloqa tarixi va fayllarni ko'chiramiz. Ko'chirish barcha tariflar narxiga kiradi. Ishga tushirishdan oldin bir necha kun ikkala tizim parallel ishlaydi — shunda hech qanday yozuv yo'qolmasligiga ishonch hosil qilasiz. Ko'chirishdan oldin bazani tozalaymiz: takror yozuvlar birlashtiriladi, bo'sh kartalar olib tashlanadi.",
            },
            {
                q: "CRM'ni 1C va telefoniya bilan bog'lash mumkinmi?",
                a: "Ha. Business va Enterprise tariflarida 1C yoki boshqa buxgalteriya dasturi bilan ikki tomonlama sinxronizatsiya bor: kontragentlar, hisob-fakturalar va to'lovlar avtomatik almashinadi. IP-telefoniya ulanganda qo'ng'iroqlar yozib olinadi va mijoz kartasiga biriktiriladi, javobsiz qo'ng'iroq esa vazifaga aylanadi. Payme, Click va bank ekvayringi ham ulanishi mumkin — to'lov holati kartada o'zi yangilanadi.",
            },
            {
                q: "Ma'lumotlar qayerda saqlanadi va ular xavfsizmi?",
                a: "Joyni siz tanlaysiz: biz tavsiya qilgan bulut serverida yoki kompaniyangizning o'z serverida. Ikkala holatda ham baza sizga tegishli. HTTPS shifrlash, rollar bo'yicha kirish cheklovi, har kunlik avtomatik zaxira nusxa va amallar jurnali standart tarzda sozlanadi. Kim qaysi yozuvni o'zgartirgani jurnalda qoladi, eksport huquqini esa faqat tanlangan rollarga beramiz.",
            },
            {
                q: "Kod kimga tegishli bo'ladi?",
                a: "Sizga. Loyiha sizning Git repozitoriyingizda olib boriladi, topshirishda barcha kod, texnik hujjatlar va server kirish huquqlari to'liq sizga o'tadi. Kelajakda boshqa jamoa ham loyihani davom ettira oladi. Biz mijozni texnik jihatdan bog'lab qo'yishni ishlash usuli deb hisoblamaymiz. Shartnomada bu band alohida yoziladi, og'zaki va'da bilan qolmaydi.",
            },
            {
                q: "Xodimlar yangi tizimga o'rganib keta oladimi?",
                a: "Aynan shuning uchun ortiqcha funksiyalarni qurmaymiz: menejer faqat o'ziga kerak bo'lgan maydon va tugmani ko'radi. Bundan tashqari, jonli o'qitish sessiyasi, o'zbek tilidagi video-qo'llanma va birinchi haftalarda kuzatuv barcha tariflarga kiradi. Odatda asosiy amallar bir kunda o'zlashtiriladi. Qarshilik bo'lsa, sababi ko'pincha interfeys emas — nazorat: buni rahbar bilan oldindan gaplashib olamiz.",
            },
            {
                q: "CRM qachon kerak emas?",
                a: "Agar oyiga 20–30 ta ariza olsangiz va ularni bitta odam yuritsa, CRM hozircha ortiqcha xarajat bo'ladi. Bunday holda Excel yoki Google Sheets yetarli. CRM ariza oqimi kunlik hisobga o'tganda, savdo bo'limida bir necha menejer ishlaganda va yo'qolgan bitimlar pul yo'qotishga aylanganda o'zini oqlaydi.",
            },
        ],
    },

    cta: {
        h: "Savdo jarayoningizni tizimga aylantiramizmi?",
        p: "Bepul konsultatsiyada savdo jarayoningizni birga ko'rib chiqamiz, qaysi modullar zarurligini aniqlaymiz va aniq narx bilan muddatni yozma ravishda beramiz. Majburiyat yo'q. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Grandpharm uchun qurilgan CRM va logistika tizimi boshqaruv paneli",
            caption: "Grandpharm — marshrutizatsiya, ichki boshqaruv tizimi va Telegram bot bitta ekotizimda.",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "Tez Lift servis kompaniyasi uchun arizalar va vazifalarni boshqarish CRM tizimi",
            caption: "Tez Lift — lift servisi arizalari, brigadalar va texnik ko'rik jadvali bitta tizimda.",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Family Group kompaniyasi uchun mijozlar bazasi va savdo voronkasi interfeysi",
            caption: "Family Group — mijozlar bazasi va savdo voronkasi menejerlar kesimida.",
        },
        {
            src: "/assets/img/projects/befitpro.webp",
            alt: "BEFIT PRO yetkazib berish tizimi buyurtmalar va mijozlar moduli ekrani",
            caption: "BEFIT PRO — buyurtmalar, mijozlar va yetkazib berish marshrutlari nazorati.",
        },
    ],

    related: ["erp-tizimlar", "biznes-avtomatlashtirish", "telegram-bot", "veb-ilovalar"],
};

const ru = {
    meta: {
        title: "CRM-системы — разработка CRM под ваш бизнес, от 18 млн сум",
        description:
            "Разработка CRM-систем: воронка продаж, база клиентов, отчёты. Не шаблон — под ваш процесс. От 18 млн сум, без ежемесячной абонплаты.",
        keywords: [
            "CRM-системы",
            "разработка CRM",
            "создание CRM цена",
            "система управления клиентами",
            "автоматизация продаж",
            "индивидуальная CRM",
            "альтернатива amoCRM",
            "альтернатива Битрикс24",
            "CRM Ташкент",
        ],
    },

    hero: {
        eyebrow: "CRM-системы",
        h1: "CRM-системы — управление продажами под ваш бизнес",
        lead:
            "Мы не настраиваем готовые шаблоны CRM. Сначала разбираем ваш процесс продаж, затем строим систему именно под него. Результат: никаких лишних кнопок и ежемесячной абонплаты, а код и база клиентов принадлежат вам.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "200+ сданных проектов",
            "Запуск за 8–14 недель",
            "Без ежемесячной абонплаты",
            "Код и база полностью ваши",
        ],
    },

    intro: {
        h: "Что такое CRM-система и чем она отличается от готовой программы",
        p: [
            "CRM (Customer Relationship Management) — система, которая держит в одном окне базу клиентов, воронку продаж, задачи и отчёты. Она собирает вместе звонок, сообщение в Instagram и заявку из Telegram. Всегда видно, на каком этапе клиент, кто за него отвечает и когда нужен следующий шаг.",
            "Готовые CRM — amoCRM, Битрикс24 и подобные — сделаны универсальными. То есть ни одной компании они не подходят полностью. Отсюда две проблемы. Первая: вы подстраиваете свой процесс под систему, а не наоборот. Вторая: каждый месяц платите подписку за каждого сотрудника. При команде в 15 человек за три-четыре года эта сумма превысит стоимость собственной системы.",
            "Innobek строит CRM-системы с нуля. Сначала рисуем карту процесса: из какого канала приходит клиент, кто с ним общается, какие этапы проходит, какие документы нужны. Затем по этой карте пишем модули. Неиспользуемые поля не создаются — менеджер осваивает систему за день, а не за неделю.",
            "Скажем честно: CRM нужна не каждому бизнесу. Если заявок 20–30 в месяц и ведёт их один человек, Excel пока справляется. CRM окупается, когда поток заявок становится ежедневным, когда в отделе продаж больше двух человек или когда забытые сделки начинают стоить денег.",
            "Ещё один важный момент: CRM — не волшебная кнопка. Если ваш процесс продаж держится на устных договорённостях и никто их не фиксирует, система просто оцифрует беспорядок. Поэтому мы начинаем проект не с разработки, а с наведения порядка в процессе. Часто уже на этапе разбора заказчик сам замечает лишние согласования и повторяющиеся шаги — и эта выгода бывает дороже самой системы.",
        ],
    },

    definition: {
        term: "Что такое CRM-система?",
        text:
            "CRM-система — программа, которая объединяет базу клиентов, воронку продаж, задачи и отчёты в одной базе данных и контролирует продажу от первого контакта до оплаты. Индивидуальная CRM пишется не на основе шаблона, а под собственный процесс компании.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в каждый тариф по умолчанию",
        sub: "Это не «дополнительные опции» с отдельным счётом — они есть даже в базовом тарифе.",
        items: [
            "Бесплатная консультация и разбор процесса продаж",
            "Карта процесса: откуда приходит клиент и какие этапы проходит",
            "Прототип интерфейса и дизайн в Figma",
            "Перенос старых данных: Excel, amoCRM, Битрикс24",
            "Настройка ролей и прав доступа",
            "Установка на сервер, домен и HTTPS-сертификат",
            "Ежедневное автоматическое резервное копирование",
            "Обучение сотрудников и видеоинструкция",
            "Git-репозиторий и полное владение кодом",
            "Техническая документация: описание модулей и руководство администратора",
            "Проверка и доработка интерфейса в мобильном браузере",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем нужно",
        h: "Что CRM-система даёт бизнесу",
        sub: "CRM — не расход, а инструмент, который возвращает теряемые сделки. Ниже — что именно она решает.",
        items: [
            {
                t: "Заявки не теряются",
                d: "Instagram Direct, звонок, форма на сайте и сообщение в Telegram попадают в одну воронку. Причина «забыли» исчезает, потому что у каждой заявки есть срок и ответственный.",
            },
            {
                t: "Не платите каждый месяц",
                d: "Готовая CRM берёт подписку за каждого сотрудника. В индивидуальной системе оплата разовая. Чем больше растёт команда, тем сильнее экономия — за нового менеджера лицензию покупать не нужно.",
            },
            {
                t: "Процесс остаётся вашим",
                d: "Этапы воронки, поля и формы документов подстраиваются под вашу манеру работы. Мы подгоняем программу под бизнес, а не бизнес под программу — это главное отличие.",
            },
            {
                t: "Работа менеджера видна в цифрах",
                d: "Кто сколько заявок взял, сколько превратилось в сделки, где застряло, какое среднее время ответа. Вместо споров — отчёт, и премия опирается на те же цифры.",
            },
            {
                t: "База остаётся в компании",
                d: "Данные лежат на вашем сервере или в выбранном вами облаке. Когда менеджер уходит, база клиентов не уходит вместе с контактами в его телефоне.",
            },
            {
                t: "Расширяется по мере роста",
                d: "Склад, документооборот, финансы или HR-модуль добавляются позже. Не нужно переходить на другой тариф или мигрировать в чужую систему — растёт одна и та же кодовая база.",
            },
            {
                t: "Меньше ручной работы",
                d: "Договор, счёт-фактура и акт формируются из шаблона автоматически. Менеджер тратит час-два в день не на набор документов, а на разговор с клиентом. Ошибок и переделок тоже становится меньше.",
            },
            {
                t: "Новый сотрудник включается быстрее",
                d: "Этапы воронки и задачи сами подсказывают новому менеджеру, что делать дальше. Период адаптации сокращается с недель до дней, а клиент не замечает смены сотрудника.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Каким компаниям подходит индивидуальная CRM",
        sub: "Тем, чей процесс нестандартен или не помещается в готовую систему.",
        items: [
            {
                t: "Оптовая торговля и дистрибуция",
                d: "Дилеры, индивидуальные прайсы для каждого клиента, контроль задолженности и заказы, связанные со складом.",
            },
            {
                t: "Производство",
                d: "От заказа до готовой продукции: калькуляция, этапы, запасы сырья и контроль сроков.",
            },
            {
                t: "Логистика и грузоперевозки",
                d: "Заявка, маршрут, водитель, документооборот и история общения с клиентом в одной системе.",
            },
            {
                t: "Строительство и монтаж",
                d: "Контроль по объектам: сметы, этапы, подрядчики и акты выполненных работ.",
            },
            {
                t: "Клиники и сервисные центры",
                d: "Карта пациента, запись, история услуг и напоминания о повторном визите с соблюдением конфиденциальности.",
            },
            {
                t: "Образовательные центры",
                d: "Заявка, пробный урок, группы, график оплат и посещаемость — с учётом учебного процесса.",
            },
            {
                t: "Агентства недвижимости",
                d: "База объектов, график показов, комиссия агентов и сделки в разрезе покупателя и продавца.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость CRM-системы — три тарифа",
        sub: "Цены открытые и разовые. Доплаты за количество пользователей нет.",
        note:
            "Окончательный расчёт подтверждается после бесплатного разбора процесса, исходя из списка модулей. Оплата поэтапная: аванс, промежуточная сдача и финал. Стоимость сервера или облака (обычно от 300 тысяч сум в месяц) в цену не входит и платится напрямую провайдеру. Вопросы — по телефону +998 90 954 12 62.",
        tiers: [
            {
                name: "Start",
                tagline: "CRM для отдела продаж",
                price: "18 000 000",
                priceNote: "сум и выше",
                term: "5–8 недель",
                best: "Перестать терять заявки и навести порядок в отделе продаж",
                features: [
                    "Разбор процесса и построение воронки по вашим этапам",
                    "База клиентов и компаний, полная история контактов",
                    "Сделки и канбан-доска с перетаскиванием по этапам",
                    "Задачи, напоминания и календарь",
                    "Роли: менеджер, руководитель отдела, администратор",
                    "Автоприём заявок с форм сайта и из Telegram",
                    "Уведомления о новой заявке через Telegram-бот",
                    "Базовые отчёты: воронка, срез по менеджерам, конверсия",
                    "Перенос данных из Excel и выгрузка",
                    "Обучение и 6 месяцев технической поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "CRM и процессы компании",
                price: "38 000 000",
                priceNote: "сум и выше",
                term: "10–16 недель",
                best: "Собрать в одной системе не только продажи, но и склад, документы и финансы",
                featured: true,
                features: [
                    "Все возможности тарифа Start",
                    "Учёт склада и остатков, база поставщиков",
                    "Документы: договор, счёт-фактура, акт — формируются автоматически",
                    "Финансовый блок: платежи, задолженность, касса и отчёт о доходах",
                    "Двусторонняя интеграция с 1С или бухгалтерской программой",
                    "IP-телефония: запись звонка и привязка к карточке клиента",
                    "Автоматизация: при смене этапа задача и документ создаются сами",
                    "Панель руководителя: показатели KPI в реальном времени",
                    "Полная адаптация под мобильный браузер или PWA",
                    "Разрезы по филиалам и подразделениям",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Решение со сложными интеграциями",
                price: "По договорённости",
                priceNote: "индивидуально",
                term: "По проекту",
                best: "Холдинги, компании с несколькими юрлицами и сложными интеграциями",
                features: [
                    "Модули уровня ERP: производство, бюджет, HR",
                    "Отдельный B2B-портал для дилеров и партнёров",
                    "Мобильное приложение для выездных сотрудников (iOS и Android)",
                    "Искусственный интеллект: скоринг заявок и прогноз продаж",
                    "Работа с несколькими юрлицами и валютами",
                    "Аудит безопасности, журнал действий и политика резервных копий",
                    "Размещение данных на вашем сервере (on-premise)",
                    "Постоянная поддержка по согласованному SLA",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как строится CRM-система",
        sub: "Шесть этапов. Самый важный — первый: до написания кода нужно понять процесс.",
        steps: [
            {
                t: "Разбор процесса",
                time: "1–2 недели",
                d: "Рисуем ваш процесс продаж вместе с менеджерами: откуда приходит клиент, кто с ним работает, какие этапы и документы есть. Часто именно здесь находятся лишние шаги.",
            },
            {
                t: "Техническое задание",
                time: "3–5 дней",
                d: "Модули, роли, поля и отчёты фиксируются письменно. Именно на основе этого документа закрепляются цена и срок — потом не возникает «мы это не учли».",
            },
            {
                t: "Дизайн интерфейса",
                time: "1–2 недели",
                d: "Готовим прототип в Figma. Сотрудники кликают по нему, и неудобства правятся до написания кода. Этот этап заметно сокращает будущие переделки.",
            },
            {
                t: "Разработка",
                time: "3–10 недель",
                d: "Модули строятся по очереди и показываются вам каждые две недели. Интеграции — 1С, телефония, Telegram, платёжные системы — подключаются на этом же этапе.",
            },
            {
                t: "Перенос данных и обучение",
                time: "1–2 недели",
                d: "Переносим старую базу, обучаем сотрудников. Несколько дней старая и новая системы работают параллельно — это защищает от потери данных.",
            },
            {
                t: "Запуск и наблюдение",
                time: "6 месяцев",
                d: "Система запускается полностью. В первые недели мы наблюдаем за использованием, вносим правки по реальной работе и бесплатно устраняем ошибки.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Системы управления, которые мы построили",
        sub: "Каждая система сделана с нуля: разбор процесса, дизайн и разработка выполнены нами.",
        cta: "Все проекты",
        slugs: ["grandpharm", "tezlift", "family-group", "befitpro"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на самые частые вопросы о CRM-системах.",
        items: [
            {
                q: "Сколько стоит разработка CRM-системы?",
                a: "Цены начинаются от 18 000 000 сум. В эту сумму входит полноценная CRM для отдела продаж: база клиентов, воронка, задачи, роли, уведомления в Telegram и отчёты. Если добавить склад, документооборот, финансы и интеграцию с 1С, стоимость начинается от 38 000 000 сум. Точную цифру называем после бесплатного разбора процесса.",
            },
            {
                q: "Сколько времени занимает разработка CRM?",
                a: "Тариф Start сдаётся за 5–8 недель, тариф Business — за 10–16 недель. Срок зависит от числа модулей и интеграций. Подключение 1С или телефонии обычно добавляет 1–2 недели. Самый долгий этап — не разработка, а разбор и согласование, поэтому чем быстрее отвечает ваша команда, тем раньше закончится проект.",
            },
            {
                q: "Почему индивидуальная система, а не готовая CRM?",
                a: "Готовая CRM сделана универсальной, поэтому ни одной компании не подходит полностью. Вы подстраиваете свой процесс под систему и платите каждый месяц за каждого пользователя. В индивидуальной всё наоборот: программа подстраивается под ваши этапы, оплата разовая, а код остаётся вашей собственностью.",
            },
            {
                q: "Разве индивидуальная CRM не дороже готовой?",
                a: "Первый платёж больше, это правда. Но готовая CRM оплачивается ежемесячно и за каждого пользователя. При команде в 10–20 человек за три-четыре года сумма подписки превысит стоимость собственной системы. Плюс вы всё равно доплачиваете за доработки и интеграции. На длинной дистанции своя система выходит дешевле.",
            },
            {
                q: "Можно ли перенести данные из amoCRM или Битрикс24?",
                a: "Да. Мы переносим клиентов, сделки, историю общения и файлы из amoCRM, Битрикс24, таблиц Excel или другой системы. Перенос входит в стоимость всех тарифов. Перед запуском обе системы несколько дней работают параллельно, чтобы вы убедились: ни одна запись не потерялась. Перед переносом базу чистим — дубли объединяем, пустые карточки убираем.",
            },
            {
                q: "Можно ли связать CRM с 1С и телефонией?",
                a: "Да. В тарифах Business и Enterprise есть двусторонняя синхронизация с 1С или другой бухгалтерской программой: контрагенты, счета и платежи обмениваются автоматически. При подключении IP-телефонии звонки записываются и привязываются к карточке клиента, а пропущенный звонок превращается в задачу. Payme, Click и банковский эквайринг тоже подключаются — статус оплаты обновляется в карточке сам.",
            },
            {
                q: "Где хранятся данные и насколько они защищены?",
                a: "Место выбираете вы: рекомендованный нами облачный сервер или собственный сервер компании. В обоих случаях база принадлежит вам. Шифрование HTTPS, ограничение доступа по ролям, ежедневное автоматическое резервное копирование и журнал действий настраиваются по умолчанию. Кто какую запись изменил — остаётся в журнале, а право на выгрузку получают только выбранные роли.",
            },
            {
                q: "Кому принадлежит код?",
                a: "Вам. Проект ведётся в вашем Git-репозитории, при сдаче весь код, техническая документация и доступы к серверу полностью переходят к вам. В будущем проект сможет продолжить и другая команда. Мы не считаем техническую привязку клиента нормальным способом работы. В договоре этот пункт прописывается отдельно, а не остаётся устным обещанием.",
            },
            {
                q: "Смогут ли сотрудники освоить новую систему?",
                a: "Да, и именно поэтому мы не строим лишних функций: менеджер видит только нужные ему поля и кнопки. Кроме того, живое обучение, видеоинструкция на русском языке и наблюдение в первые недели входят во все тарифы. Обычно основные действия осваиваются за один день. Если возникает сопротивление, причина чаще не в интерфейсе, а в контроле — это мы обсуждаем с руководителем заранее.",
            },
            {
                q: "Когда CRM не нужна?",
                a: "Если заявок 20–30 в месяц и ведёт их один человек, CRM пока будет лишним расходом. В такой ситуации хватает Excel или Google Таблиц. CRM окупается, когда поток заявок становится ежедневным, в отделе работает несколько менеджеров, а потерянные сделки превращаются в потерянные деньги.",
            },
        ],
    },

    cta: {
        h: "Превратим ваш процесс продаж в систему?",
        p: "На бесплатной консультации разберём ваш процесс продаж, определим нужные модули и письменно зафиксируем точную цену и срок. Без обязательств. Телефон: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Панель управления CRM и логистической системы, построенной для Grandpharm",
            caption: "Grandpharm — маршрутизация, внутренняя система управления и Telegram-бот в одной экосистеме.",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "CRM-система управления заявками и задачами для сервисной компании Tez Lift",
            caption: "Tez Lift — заявки лифтового сервиса, бригады и график техосмотра в одной системе.",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Интерфейс базы клиентов и воронки продаж для компании Family Group",
            caption: "Family Group — база клиентов и воронка продаж в разрезе менеджеров.",
        },
        {
            src: "/assets/img/projects/befitpro.webp",
            alt: "Экран модуля заказов и клиентов системы доставки BEFIT PRO",
            caption: "BEFIT PRO — контроль заказов, клиентов и маршрутов доставки.",
        },
    ],

    related: ["erp-tizimlar", "biznes-avtomatlashtirish", "telegram-bot", "veb-ilovalar"],
};

const content = { uz, ru };

export default content;
